import * as React from 'react';

export const IconConnectionError = (props: React.SVGProps<SVGSVGElement>) => (
	<svg fill="currentColor" viewBox="0 0 24 24" {...props}>
		<defs>
			<marker id="prefix__a" refX={0} refY={0} orient="auto" overflow="visible">
				<g fill="none">
					<path d="M0 0h2" strokeWidth={1.15} strokeLinecap="square" />
					<path d="M0 0l13 4-4-4 4-4L0 0z" fillRule="evenodd" />
					<path d="M0-4v44" strokeLinecap="square" />
				</g>
			</marker>
		</defs>
		<path d="M0 0h24v24H0z" fill="none" markerMid="url(#prefix__a)" />
		<g transform="translate(-9.488 -17.84) scale(1.8622)">
			<circle r={0.962} cx={11.517} cy={19.883} fill="currentColor" />
			<rect ry={0.35} y={11.978} x={10.55} height={6.033} width={1.933} fill="currentColor" />
			<g fill="none" stroke="currentColor" strokeWidth={1.2}>
				<path d="M7.754 17.38a4.52 4.52 0 012.058-1.682M5.712 16.022a6.972 6.972 0 013.174-2.595" />
			</g>
			<g fill="none" stroke="currentColor" strokeWidth={1.2}>
				<path d="M15.408 17.38a4.52 4.52 0 00-2.058-1.682M17.45 16.022a6.972 6.972 0 00-3.175-2.595" />
			</g>
		</g>
	</svg>
);
